const jQ = jQuery.noConflict();


class lockScreen{

    constructor(){
        this.html = jQ('html');
        this.body = jQ('body');
        this.headerMain = jQ('.header-main');
        this.scrollTop;
    }

    lock() {


        let windowHeight = jQ(window).height();
        this.scrollTop = jQ(window).scrollTop();

        if (jQ(window).scrollTop() > 100) {
            this.headerMain.addClass("header-minimized-lock");
            this.body.addClass("header-minimized-lock");
        }

        this.html.css({
            height: windowHeight,
            overflow: 'hidden'
        });

        this.body.css({
            // height: windowHeight + this.scrollTop +'px',
            // overflow: 'hidden',
            // marginTop: '-'+ this.scrollTop +'px'
        });
    }

        unlock() {

            this.html.add(this.body).attr('style', '');
            jQ(window).scrollTop(this.scrollTop);

            if(jQ(this.headerMain).hasClass("header-minimized-lock")){
                jQ(this.headerMain).removeClass("header-minimized-lock");
                jQ(this.body).removeClass("header-minimized-lock");
            }

    }

}

const screenLock = new lockScreen();

export default screenLock;



// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/lockscreen.js